'use client'

/**
 * PostHog Pageview Tracker
 * Captures manual $pageview events on route changes
 * Required because capture_pageview is disabled in instrumentation-client.ts
 * for Next.js App Router compatibility
 */

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import '../../instrumentation-client'
import posthog from 'posthog-js'

export default function PostHogPageView(): null {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname
      
      // Append search params to URL for complete tracking
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`
      }

      // Capture pageview with URL and route
      posthog.capture('$pageview', {
        $current_url: url,
        route: pathname,
      })
    }
  }, [pathname, searchParams])

  return null
}
